export default __webpack_public_path__ + "static/media/tiktok.bbb04669.svg";